import Image from 'next/image';

import { Box, Flex, Text } from '@chakra-ui/react';

import { RplQuote } from '../constants';

export function RplQuoteCard({ quote, tone = 'light' }: { quote: RplQuote; tone?: 'dark' | 'light' }) {
  const isDark = tone === 'dark';

  return (
    <Flex alignItems='flex-start' as='figure' direction='row' gap={{ base: '12px', md: '16px' }} m={0} minW={0}>
      <Box
        bg='gold.100'
        borderRadius='4px'
        flexShrink={0}
        h={{ base: '88px', md: '128px' }}
        overflow='hidden'
        position='relative'
        w={{ base: '88px', md: '128px' }}
      >
        <Image alt='' sizes='128px' src={quote.imageSrc} style={{ objectFit: 'contain' }} fill />
      </Box>
      <Flex direction='column' flex={1} gap='12px' justifyContent='space-between' minW={0}>
        <Text as='blockquote' color={isDark ? 'white' : 'grey.900'} fontSize='sm' lineHeight='1.5'>
          &ldquo;{quote.quote}&rdquo;
        </Text>
        <Flex as='figcaption' direction='column' minW={0}>
          <Text color={isDark ? 'gold.300' : 'grey.900'} fontSize='sm' fontWeight='600' lineHeight='1.3'>
            {quote.name}
          </Text>
          <Text color={isDark ? 'grey.300' : 'grey.500'} fontSize='sm' lineHeight='1.4'>
            {quote.role}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
